function Loading() {
  return <div>Cargando...</div>;
}

export default Loading;
